import { Container } from "components/layout/styles"
import styled from "styled-components"
import { maxWidth, minWidth } from "utils"

export const StyledCardCategory = styled.div`
  width: 100%;
  height: 40rem;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: ${(props) => `url("${props.background}")`};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${maxWidth.desktopL`
    height: 36rem;
  `}
`

export const MainContainer = styled(Container)`
  padding: 1rem 1rem;
  margin-top: 2rem;
`

export const BackgroundShadow = styled.div`
  display: block;
  height: 25rem;
  background-blend-mode: hard-light;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.6) 40%,
    rgba(0, 0, 0, 0.6) 61%,
    rgba(0, 0, 0, 0)
  );

  ${minWidth.desktopL`
    height: 36rem;
  `}
`

export const HeadingContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
